import React from 'react';
import Dental from 'assets/img/addons/dental.svg';
import Outpatient from 'assets/img/addons/outpatient.svg';
import Maternity from 'assets/img/addons/maternity.svg';
import Screenings from 'assets/img/addons/screenings-vaccines.svg';
import Deductible from 'assets/img/addons/deductible.svg';
import Coverage from 'assets/img/addons/coverage.svg';
import Retirement from 'assets/img/addons/retirement.svg';
import Travel from 'assets/img/addons/travel.svg';
import Dependants from 'assets/img/addons/dependants.svg';
import Vision from 'assets/img/addons/vision.svg';

import DentalLight from 'assets/img/addons/dental-light.svg';
import DeductibleLight from 'assets/img/addons/deductible-light.svg';
import CoverageLight from 'assets/img/addons/coverage-light.svg';
import OutpatientLight from 'assets/img/addons/outpatient-light.svg';

import { providers as rhProviders, COMPANY_PLAN_TYPES } from 'assets/consts';

import USCoverage from 'products/nomad_insurance/assets/img/addons/us_coverage.svg';
import Sports from 'products/nomad_insurance/assets/img/addons/sports.svg';
import Electronics from 'products/nomad_insurance/assets/img/addons/electronics.svg';

export const NHI_ADDONS = (variant) => {
  return [
    {
      value: 'DEPENDANTS',
      img: Dependants,
      name: 'Family members',
      tooltip:
        'Allows members to cover family members. The price per family member is the same as for other members (corresponding to age).'
    },
    {
      value: 'DENTAL',
      img: variant === 'light' ? DentalLight : Dental,
      name: 'Dental',
      tooltip: [
        '$1.5K USD in dental coverage for when you need to see a dentist for routine care such as check-ups, fillings etc. or more complex care like repairing or receiving new crowns, dentures, or inlays.',
        <br />,
        `${
          variant === 'light'
            ? 'The first year, there is a 9 month build-up period before the benefit becomes available and you can get your dentist appointments covered.'
            : 'If you are signing up as a company of less than 10 members: the first year, there is a 9 month build-up period before the benefit becomes available and you can get your dentist appointment covered.'
        }`
      ]
    },
    {
      value: 'DEDUCTIBLE',
      img: variant === 'light' ? DeductibleLight : Deductible,
      name: '$0 deductible',
      tooltip:
        'Your deductible determines how much you must pay out of pocket before receiving reimbursement for claims within one year. Default is $250 USD.'
    },
    {
      value: 'COVERAGE',
      img: variant === 'light' ? CoverageLight : Coverage,
      name: 'Coverage in US, HK, & SG',
      tooltip:
        'Also get coverage for travel up to 6 months in the US, Hong Kong, and Singapore (base plan only includes emergency coverage on planned trips up to 30 days).'
    },
    {
      value: 'OUTPATIENT',
      img: variant === 'light' ? OutpatientLight : Outpatient,
      name: 'Outpatient',
      tooltip: [
        'Outpatient care is when you need medical services outside of being admitted to the hospital (for example: family doctor, physiotherapy etc.).',
        <br />,
        '10% co-pay, so for a $150 appointment you get reimbursed $135.'
      ]
    },
    {
      value: 'MATERNITY',
      img: Maternity,
      name: 'Maternity',
      tooltip: [
        'Coverage for when you are pregnant and need routine check- ups, scans, and delivery costs taken care of.',
        <br />,
        'Up to to $5, 000K USD for routine maternity care with a co- pay of 20%.',
        <br />,
        'There is a 12 month waiting period before coverage activates for groups < 10 members.'
      ]
    },
    {
      value: 'SCREENING',
      img: Screenings,
      name: 'Screenings & vaccines',
      tooltip: [
        'Covers up to $250 USD per year across two categories:',
        <br />,
        'i) Screenings: routine health checks including Cancer screening, cardiovascular examination, and vital signs (e.g.blood pressure, body mass index etc.).',
        <br />,
        'ii) Vaccinations: cost of drugs and consultations to administer all necessary basic immunization and booster injections for travel or otherwise.'
      ]
    },
    {
      value: 'RETIREMENT',
      img: Retirement,
      name: 'Retirement',
      comingSoon: true
    },
    {
      value: 'VISION',
      img: Vision,
      name: 'Vision'
    },
    { value: 'TRAVEL', img: Travel, name: 'Travel', comingSoon: true }
  ];
};

export const VUMI_VIP_ADDONS = (variant) => {
  return [
    {
      value: 'VISION',
      img: Vision,
      name: 'Vision',
      tooltip:
        'Up to $100/$500 USD to cover: Eye exam once every 12 months, frame once every 24 months, standard lens enhancements once every 12 months, contact lenses (instead of eye glasses) once every 12 months'
    },
    {
      value: 'DEPENDANTS',
      img: Dependants,
      name: 'Family members',
      tooltip:
        'Allows members to cover family members. The price per family member is the same as for other members (corresponding to age).'
    },
    {
      value: 'DENTAL',
      img: variant === 'light' ? DentalLight : Dental,
      name: 'Dental',
      tooltip: [
        '$1,000 USD in dental coverage (no orthodontia) for when you need to see a dentist for routine care such as check-ups, fillings etc. or more complex care like repairing or receiving new crowns, dentures, or inlays. Orthodontics is not covered.',
        <br />,
        `If you are signing up as a company of less than 5 members: the first year, there is a 9 month build-up period before the benefit becomes available and you can get your dentist appointment covered.`
      ]
    },
    {
      value: 'DEDUCTIBLE',
      img: variant === 'light' ? DeductibleLight : Deductible,
      name: '$0 deductible',
      tooltip:
        'Your deductible determines how much you must pay out of pocket before receiving reimbursement for claims within one year. Default is $250 USD.'
    },
    {
      value: 'COVERAGE',
      img: variant === 'light' ? CoverageLight : Coverage,
      name: 'Coverage in US, HK, & SG',
      tooltip:
        'Also get full coverage for travel up to 6 months in the United States (US), Hong Kong (HK) and Singapore (SG) (base plan only includes emergency coverage subject to limitations).'
    },
    {
      value: 'OUTPATIENT',
      img: variant === 'light' ? OutpatientLight : Outpatient,
      name: 'Outpatient',
      tooltip: [
        'Outpatient care is when you need medical services outside of being admitted to the hospital (for example: family doctor, physiotherapy etc.).',
        <br />,
        'Option I: $1,000 USD',
        <br />,
        'Option II: $5,000 USD'
      ]
    },
    {
      value: 'MATERNITY',
      img: Maternity,
      name: 'Maternity'
    },
    {
      value: 'SCREENING',
      img: Screenings,
      name: 'Screenings & vaccines',
      tooltip: [
        '$500 USD for health screenings, vaccinations and optical. This benefit excludes COVID-19 vaccinations.'
      ]
    },
    {
      value: 'RETIREMENT',
      img: Retirement,
      name: 'Retirement',
      comingSoon: true
    },
    { value: 'TRAVEL', img: Travel, name: 'Travel', comingSoon: true }
  ];
};

export const VUMI_BASIC_FLEX_ADDONS = (variant) => {
  return [
    {
      value: 'VISION',
      img: Vision,
      name: 'Vision',
      tooltip:
        'Up to $100/$500 USD to cover: Eye exam once every 12 months, frame once every 24 months, standard lens enhancements once every 12 months, contact lenses (instead of eye glasses) once every 12 months'
    },
    {
      value: 'DEPENDANTS',
      img: Dependants,
      name: 'Family members',
      tooltip:
        'Allows members to cover family members. The price per family member is the same as for other members (corresponding to age).'
    },
    {
      value: 'DENTAL',
      img: variant === 'light' ? DentalLight : Dental,
      name: 'Dental',
      tooltip: [
        '$1,000 USD in dental coverage (no orthodontia) for when you need to see a dentist for routine care such as check-ups, fillings etc. or more complex care like repairing or receiving new crowns, dentures, or inlays. Orthodontics is not covered.',
        <br />,
        `If you are signing up as a company of less than 5 members: the first year, there is a 9 month build-up period before the benefit becomes available and you can get your dentist appointment covered.`
      ]
    },
    {
      value: 'DEDUCTIBLE',
      img: variant === 'light' ? DeductibleLight : Deductible,
      name: '$0 deductible',
      tooltip:
        'Your deductible determines how much you must pay out of pocket before receiving reimbursement for claims within one year. Default is $250 USD.'
    },
    {
      value: 'COVERAGE',
      img: variant === 'light' ? CoverageLight : Coverage,
      name: 'Coverage in US, HK, & SG',
      tooltip:
        'Also get full coverage for travel up to 6 months in the United States (US), Hong Kong (HK) and Singapore (SG) (base plan only includes emergency coverage subject to limitations).'
    },
    {
      value: 'OUTPATIENT',
      img: variant === 'light' ? OutpatientLight : Outpatient,
      name: 'Outpatient',
      tooltip: [
        'Outpatient care is when you need medical services outside of being admitted to the hospital (for example: family doctor, physiotherapy etc.).',
        <br />,
        'Option I: $1,000 USD',
        <br />,
        'Option II: $5,000 USD'
      ]
    },
    {
      value: 'MATERNITY',
      img: Maternity,
      name: 'Maternity'
    },
    {
      value: 'SCREENING',
      img: Screenings,
      name: 'Screenings & vaccines',
      tooltip: [
        '$500 USD for health screenings, vaccinations and optical. This benefit excludes COVID-19 vaccinations.'
      ]
    },
    {
      value: 'RETIREMENT',
      img: Retirement,
      name: 'Retirement',
      comingSoon: true
    },
    { value: 'TRAVEL', img: Travel, name: 'Travel', comingSoon: true }
  ];
};

export const SAFETYWING_ADDONS = [
  {
    id: 8,
    value: 'USA_COVERAGE',
    img: USCoverage,
    name: 'US coverage',
    description: 'For travel to the US and US territories.',
    tooltip:
      'Coverage that includes travel to the US and US territories. Not applicable to US citizens or residents.',
    analyticsName: 'addon_ni_usCoverage'
  },
  {
    id: 10,
    value: 'SPORTS_COVERAGE',
    img: Sports,
    name: 'Adventure sports',
    description: 'For additional adventure sports like skydiving, hang gliding and more.',
    tooltip:
      'Coverage for additional adventure sports like cave diving, hang gliding, snow mobile, kite surfing, martial arts, skydiving. Full list of sports covered by SafetyWing Nomad Insurance with and without this add-on in our FAQ.',
    analyticsName: 'addon_ni_adventureSports'
  },
  {
    id: 9,
    value: 'ITEM_INSURANCE',
    img: Electronics,
    name: 'Electronics theft',
    description: 'For electronics up to $1,000 USD per item for policies > 28 days.',
    disabledDescription: 'Only available for recurring policies.',
    tooltip:
      'Coverage for electronics like laptops, tablets and cameras for up to $1000 per stolen item, with a total yearly limit of $3000 per policy.',
    analyticsName: 'addon_ni_itemInsurance'
  }
];

export const TM_ADDONS = [
  {
    id: 1,
    value: 'usa coverage',
    img: USCoverage,
    name: 'Include US coverage',
    tooltip:
      'Coverage that includes travel to the US and US territories. Not applicable to US citizens or residents.',
    analyticsName: 'addon_ni_usCoverage'
  }
];

export const AFFINITY_STANDARD = () => {
  return [
    {
      value: 'DEPENDANTS',
      img: Dependants,
      name: 'Family members',
      tooltip:
        'Add your spouse, domestic partner, and children to the plan for an extra premium so they can receive the same services you do.'
    },
    {
      value: 'DEDUCTIBLE',
      img: Deductible,
      name: '$0 deductible',
      tooltip:
        'Deductible determines how much you must pay out of pocket before receiving reimbursement for claims within one year.'
    },
    {
      value: 'OUTPATIENT',
      img: Outpatient,
      name: 'Outpatient',
      tooltip: [
        'Outpatient care is when you need medical services without being admitted to the hospital. A 10% co-pay will need to be covered by you. Maximum of $5,000 across all outpatient charges.'
      ]
    }
  ];
};

export const AFFINITY_PREMIUM = () => {
  return [
    {
      value: 'VISION',
      img: Vision,
      name: 'Vision',
      tooltip:
        'Eye exams, standard lens enhancement, and contact lenses once every 12 months; eyeglasses once every 24 months. Maximum coverage is $500 USD.'
    },
    {
      value: 'DEPENDANTS',
      img: Dependants,
      name: 'Family members',
      tooltip:
        'Add your spouse, domestic partner, and children to the plan for an extra premium so they can receive the same services you do.'
    },
    {
      value: 'DENTAL',
      img: Dental,
      name: 'Dental',
      tooltip: [
        'Dental coverage for routine care such as check-ups, fillings, etc., or more complex care like repairing or receiving new crowns, dentures, or inlays. This benefit is subject to a 9 month waiting period with maximum coverage of $1,000.'
      ]
    },
    {
      value: 'DEDUCTIBLE',
      img: Deductible,
      name: '$0 deductible',
      tooltip:
        'Deductible determines how much you must pay out of pocket before receiving reimbursement for claims within one year.'
    },
    {
      value: 'OUTPATIENT',
      img: Outpatient,
      name: 'Outpatient',
      tooltip: [
        'Outpatient care is when you need medical services without being admitted to the hospital. A 10% co-pay will need to be covered by you. Maximum of $5,000 across all outpatient charges.'
      ]
    },
    {
      value: 'SCREENING',
      img: Screenings,
      name: 'Screenings & vaccines',
      tooltip: [
        'Routine health checks including cancer screening, cardiovascular and basic vital signs exams, as well as all basic immunization and booster injections. COVID vaccine is not covered and the maximum coverage is $500.'
      ]
    }
  ];
};

export const AFFINITY_MATERNITY = () => {
  return [
    {
      value: 'VISION',
      img: Vision,
      name: 'Vision',
      tooltip:
        'Eye exams, standard lens enhancement, and contact lenses once every 12 months; eyeglasses once every 24 months. Maximum coverage is $500 USD.'
    },
    {
      value: 'DEPENDANTS',
      img: Dependants,
      name: 'Family members',
      tooltip:
        'Add your spouse, domestic partner, and children to the plan for an extra premium so they can receive the same services you do.'
    },
    {
      value: 'DENTAL',
      img: Dental,
      name: 'Dental',
      tooltip: [
        'Dental coverage for routine care such as check-ups, fillings, etc., or more complex care like repairing or receiving new crowns, dentures, or inlays. This benefit is subject to a 9 month waiting period with maximum coverage of $1,000.'
      ]
    },
    {
      value: 'DEDUCTIBLE',
      img: Deductible,
      name: '$0 deductible',
      tooltip:
        'Deductible determines how much you must pay out of pocket before receiving reimbursement for claims within one year.'
    },
    {
      value: 'OUTPATIENT',
      img: Outpatient,
      name: 'Outpatient',
      tooltip: [
        'Outpatient care is when you need medical services without being admitted to the hospital. A 10% co-pay will need to be covered by you. Maximum of $5,000 across all outpatient charges.'
      ]
    },
    {
      value: 'SCREENING',
      img: Screenings,
      name: 'Screenings & vaccines',
      tooltip: [
        'Routine health checks including cancer screening, cardiovascular and basic vital signs exams, as well as all basic immunization and booster injections. COVID vaccine is not covered and the maximum coverage is $500.'
      ]
    },
    {
      value: 'MATERNITY',
      img: Maternity,
      name: 'Maternity',
      tooltip: [
        'Maternity: medical costs associated with pre- and post-natal checkups for up to 30 days following discharge.'
      ]
    }
  ];
};

export const getAddons = (provider, variant) => {
  switch (provider) {
    case 'SAFETYWING':
      return SAFETYWING_ADDONS;
    case 'TOKIO_MARINE':
      return TM_ADDONS;
    case COMPANY_PLAN_TYPES.AFFINITY_STANDARD:
      return AFFINITY_STANDARD();
    case COMPANY_PLAN_TYPES.AFFINITY_PREMIUM:
      return AFFINITY_PREMIUM();
    case COMPANY_PLAN_TYPES.AFFINITY_MATERNITY:
      return AFFINITY_MATERNITY();
    case rhProviders.NOW_HEALTH_GLOBAL:
      return NHI_ADDONS(variant);
    case rhProviders.VUMI_VIP:
      return VUMI_VIP_ADDONS(variant);
    case rhProviders.VUMI_BASIC_FLEX:
      return VUMI_BASIC_FLEX_ADDONS(variant);
    case rhProviders.NOW_HEALTH_US:
    case rhProviders.UNITED_HEALTHCARE:
    default:
      return [];
  }
};
